module.exports = __webpack_public_path__ + "images/create-first-board/card-back/cardBack-uk.31000950c795689857e9.svg";